import React from 'react'
import { Link } from 'react-router-dom';

function TourCard(props) {
    const { tourID, tourImage, tourTitle, tourPrice, tourDuration } = props;
    return (
        <div className="tour-box th-ani">
            <div className="tour-box_img global-img">
                <img src={`/assets/img/tour/${tourImage}`} alt="" />
            </div>
            <div className="tour-content">
                <h3 className="box-title">
                    <Link to={`/tour/${tourID}`}>{tourTitle ? tourTitle : 'Greece Tour Package'}</Link>
                </h3>
                <div className="tour-rating">
                    <div
                        className="star-rating"
                        role="img"
                        aria-label="Rated 5.00 out of 5"
                    >
                        <span style={{ width: "100%" }}>
                            Rated
                            <strong className="rating">5.00</strong> out of 5
                            based on <span className="rating">4.8</span>(4.8
                            Rating)
                        </span>
                    </div>
                    <Link
                        to={`/tour/${tourID}`}
                        className="woocommerce-review-link"
                    >
                        (<span className="count">4.8</span>
                        Rating)
                    </Link>
                </div>
                <h4 className="tour-box_price">
                    <span className="currency">{tourPrice ? tourPrice : 'Call/WhatsApp for Price'}</span>
                </h4>
                <div className="tour-action">
                    <span>
                        <i className="fa-light fa-clock" />{tourDuration ? tourDuration : '5 Days / 4 Nights'}
                    </span>
                    <Link to={`/tour/${tourID}`} className="th-btn style4">
                        Detail View
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default TourCard
